import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TextAreaOptions } from 'bnsights-control-library';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ClipboardService } from 'ngx-clipboard';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { TemplateEditViewModel } from '../../shared/models/NotificationsModels/TemplateEditViewModel';
import { DataSecretService } from '../../shared/Services/data.service';
import { TemplateService } from '../../shared/Services/TemplateService.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-edit-sms',
  templateUrl: './edit-sms.component.html'
})
export class EditSMSComponent implements OnInit {

  TemplateId: string = ""
  Lang: string = ""
  TemplateInfo: any
  IsAEditFormLoaded:boolean

  EditSMSForm = new FormGroup({});
  SMSInEnglish: TextAreaOptions;
  SMSInArabic: TextAreaOptions;
  language:string=""
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;


  constructor(private authService:AuthService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private _clipboardService: ClipboardService, private dataServices: DataSecretService,  private templateService: TemplateService, private activatedRoute: ActivatedRoute, private router: Router,private pageInfoService:PageInfoService)
  {
    this.activatedRoute.params.subscribe(params => {
      this.TemplateId = params['id'];
      this.Lang = params['lang'];
    });
  }


  async ngOnInit(): Promise<void> {
    this.IsAEditFormLoaded=false

    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.templateService.GetTemplateInfoByLang(Number(this.TemplateId), this.Lang).subscribe((result) => {
      let Result: any = result
      this.TemplateInfo = Result.val;

      let TemplateName:string= this.language=='en'?this.TemplateInfo.emailtemplateinfo.emailSubject.english:this.TemplateInfo.emailtemplateinfo.emailSubject.arabic
      if(TemplateName==null||TemplateName==undefined)
      TemplateName=""
      PageInfoService.PageTitle=this.utilityService.getResourceValue("Edit")
      PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false},
       {title: this.utilityService.getResourceValue("Templates"), path: '/Admin/Notifications/Templates', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false},
       {title:TemplateName!=""?this.utilityService.getResourceValue(TemplateName):"" , path: "/Admin/Notifications/TemplateInfo/"+this.TemplateInfo.id, isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}


    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
      this.SMSInEnglish = new TextAreaOptions();
      this.SMSInEnglish.Name = "SMSInEnglish"
      this.SMSInEnglish.LabelKey = "SMSInEnglish"
      this.SMSInEnglish.IsRequired = true
      this.SMSInEnglish.Value = this.TemplateInfo.smstemplateinfo.sms.english;

      this.SMSInArabic = new TextAreaOptions();
      this.SMSInArabic.Name = "SMSInArabic"
      this.SMSInArabic.LabelKey = "SMSInArabic"
      this.SMSInArabic.IsRequired = true
      this.SMSInArabic.Value = this.TemplateInfo.smstemplateinfo.sms.arabic;

      this.IsAEditFormLoaded=true;
    });
  }

 changeCurrentLanguage(lang:string)
 {
   this.Lang=lang;
 }

 
  editSMSTemplate(){
    if (this.EditSMSForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditSMSForm.value;
      let EmailTemplateModel = new TemplateEditViewModel();
      EmailTemplateModel.ID = Number(this.TemplateId);
      EmailTemplateModel.IDEncrypted = this.TemplateInfo.idEncrypted;
      EmailTemplateModel.IsEmail = this.TemplateInfo.isEmail;
      EmailTemplateModel.IsSms = this.TemplateInfo.isSms;
      EmailTemplateModel.TemplateName = this.TemplateInfo.templateName;
      EmailTemplateModel.Language = this.Lang;
      EmailTemplateModel.smstemplateinfo.ID =this.TemplateInfo.smstemplateinfo.id ;

      EmailTemplateModel.smstemplateinfo.SMS.Arabic = ResultModel.SMSInArabic
      EmailTemplateModel.smstemplateinfo.SMS.English = ResultModel.SMSInEnglish

      
       this.templateService.EditSMSTemplateByLang(EmailTemplateModel).subscribe((result) => {
         ;
        this.EditSMSForm.reset()
        this.close();
      }, (error) => {
       
      })
    }
  }
  close(){
    this.router.navigate(['/Admin/Notifications/TemplateInfo',this.TemplateId]);
  }

}
